// newPage/tableConfig.js
export const tableConfig = {
    columns: [
        {
          label: '',
          value: 'firstName',
          width: '5%',
          align: 'center',
          type: 'count',
        },
        {
          label: 'First Name',
          value: 'firstName',
          width: '15%',
          align: 'center',
          type: 'text',
        },
        {
          label: 'Last Name',
          value: 'lastName',
          width: '15%',
          align: 'center',
          type: 'text' ,
          search: 'lastName'  // passed as key in POST body
        },
        {
          label: 'Organization',
          value: 'organization',
          width: '15%',
          align: 'center',
          type: 'text',
          search: 'organization'  // passed as key in POST body
        },
        {
          label: 'Mobile',
          value: 'mobilePhone',
          width: '15%',
          align: 'center',
          type: 'text'
        },
        {
          label: 'Email',
          value: 'email',
          width: '20%',
          align: 'left',
          type: 'text'
        },
        {
          label: 'Role',
          value: 'role',
          width: '15%',
          align: 'center',
          type: 'text',
          search: 'role'  // passed as key in POST body
        },
  ],
    queryName: '/users/getFiltered',
    onAddNew: '/user-management/add',  // Add button route
    pageSize: 10,
    startNum: 1,
    buttons: [
        { label: 'Edit', action: '/user-management/{_id}', color: 'blue' },  // Update route
        { label: 'Delete', action: 'delete', color: 'red' }  // Enable Delete button
    ]
};
